import { Component, Inject, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { FormControl } from "@angular/forms";
import { MatOption } from "@angular/material/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { EndpointLookup } from "src/app/models/endpointLookup.model";
import { NotificationAssignmentsModel } from "src/app/models/notificationAssignments.model";
import { NotificationSettings } from "src/app/models/notificationSettings.model";
import { CustomEntityService } from "src/app/services/customEntity.service";
import { NotificationSettingsService } from "src/app/services/notificationSettings.service";
import { ToastService } from "src/app/services/toast.service";

import { trackById } from "src/app/shared/utils/track-by.util";
@Component({
  standalone: false,
    selector: "app-assign-notification-settings-dialog",
    templateUrl: "assign-notification-settings-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["assign-notification-settings-dialog.component.scss"],
})
export class AssignNotificationSettingsDialogComponent implements OnInit {
    isFormLoading = false;
    isLoading = false;
    endPoints: EndpointLookup[];
    customObjects: EndpointLookup[];
    data: NotificationAssignmentsModel;
    selectedCustomObjectId: string;
    selectedCustomObjectIcon: string;
    searchControl = new FormControl();
    filteredEndPoints: EndpointLookup[] = [];

    @ViewChild("endPointsList") protected endPointsList: MatOption;

    constructor(
        public dialogRef: MatDialogRef<AssignNotificationSettingsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public inData: NotificationSettings,
        private notificationSettingsService: NotificationSettingsService,
        private toastService: ToastService,
        private customEntityService: CustomEntityService,
    ) {}

    ngOnInit() {
        this.isFormLoading = true;
        forkJoin({
            endPoints:
                this.customEntityService.getEndPointLookupListByNotificationId(
                    this.inData.id,
                ),
            notificationAssignments:
                this.notificationSettingsService.getNotificationAssignments(
                    this.inData.id,
                ),
        }).subscribe(
            (result) => {
                this.endPoints = result.endPoints;
                this.customObjects = this.getUniqueEndPoints(result.endPoints);
                this.data = result.notificationAssignments;
                this.setSelectedCustomObject();
                this.isFormLoading = false;
            },
            (error) => {
                this.toastService.showError(error);
                this.isFormLoading = false;
            },
        );
    }

    setSelectedCustomObject() {
        if (this.data.assignedEndPoints.length > 0) {
            const assignedEndPoint = this.data.assignedEndPoints[0];
            const endPoint = this.endPoints.find(
                (ep) => ep.id === assignedEndPoint,
            );
            if (endPoint) {
                this.selectedCustomObjectId = endPoint.customObjectId;
                this.selectedCustomObjectIcon = endPoint.icon;
                this.setFilteredEndpoints();
            }
        }
    }

    getUniqueEndPoints(endPoints: EndpointLookup[]): EndpointLookup[] {
        const unique = [];
        const map = new Map();
        for (const item of endPoints) {
            if (!map.has(item.customObjectId)) {
                map.set(item.customObjectId, true);
                unique.push(item);
            }
        }
        return unique;
    }


    onEndpointSelect() {
        const selectedEndpoint = this.customObjects.find(
            (endPoint) =>
                endPoint.customObjectId === this.selectedCustomObjectId,
        );
        this.selectedCustomObjectIcon = selectedEndpoint
            ? selectedEndpoint.icon
            : "";
        this.data.assignedEndPoints = [];
        this.setFilteredEndpoints();
    }

    save() {
        this.isLoading = true;

        const payload = new NotificationAssignmentsModel();
        payload.id = this.data.id;
        payload.assignedEndPoints = this.data.assignedEndPoints.filter(
            (x) => !!x,
        );

        this.notificationSettingsService
            .saveNotificationAssignments(payload)
            .subscribe(
                (response) => {
                    this.isLoading = false;
                    this.toastService.showSuccess(
                        "Notification assignments saved successfully",
                        true,
                    );
                    this.dialogRef.close(true);
                },
                (error) => {
                    this.isLoading = false;
                    this.toastService.showError(error);
                },
            );
    }

    close() {}

    setFilteredEndpoints() {
        this.filteredEndPoints = this.endPoints.filter(
            (endPoint) =>
                endPoint.customObjectId === this.selectedCustomObjectId,
        );
    }

    toggleOneEndPointSelection() {
        if (this.endPointsList.selected) {
            this.endPointsList.deselect();
            return false;
        }
        if (
            this.data.assignedEndPoints.length === this.filteredEndPoints.length
        ) {
            this.endPointsList.select();
        }
    }

    toggleAllEndPointsSelection() {
        this.data.assignedEndPoints = [];
        if (this.endPointsList.selected) {
            this.data.assignedEndPoints = this.filteredEndPoints.map(
                (endPoint) => endPoint.id,
            );
            this.data.assignedEndPoints.push('');
        }
    }

    public trackById = trackById;
}
